import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-popup-datapurchase-terms',
  templateUrl: './popup-datapurchase-terms.component.html',
  styleUrls: ['./popup-datapurchase-terms.component.sass']
})
export class PopupDatapurchaseTermsComponent implements OnInit {

  constructor(public matDialogRef: MatDialogRef<PopupDatapurchaseTermsComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  public close() {
    this.matDialogRef.close('cancel');
  }

}
